<template>
<div> 
    <div class="print" id="printMe" >
      <print-invoice></print-invoice>
    </div>

    <div style="">    
    <div>
        <v-alert
                :value="isError"
                type="error"
                dark
                border="top"
                transition="scale-transition">
            {{errorMessage}}
        </v-alert>
        <v-alert
                :value="isSuccess"
                type="success"
                dark
                border="top"
                transition="scale-transition">
            {{successMessage}}
        </v-alert>
      <div class="d-flex flex-row v-panel">
        <customer-panel ref="customerPanel" :class="isCustomerOnly ? 'col-md-12' : 'col-md-4'"> </customer-panel>
        <invoice-detail-panel v-if="!isCustomerOnly" ref="invoiceDetailPanel" class="invoice-panel col-md-5"> </invoice-detail-panel>
      </div>
    </div>
    <div v-if="!isCustomerOnly" class="passenger-details-container v-panel">
      <passenger-detail-panel ref="passengerDetailComponent"> </passenger-detail-panel>
    </div>
    <div v-if="!isCustomerOnly" class="passenger-details-container v-panel">
      <itinerary-detail-panel ref="itineraryDetailPanel"> </itinerary-detail-panel>
    </div>
    <div v-if="!isCustomerOnly" style="flex-direction:row; display: flex;flex-wrap: wrap;">
      <services-detail-panel ref="serviceDetailPanel" class="bottom-panels col-md-3"></services-detail-panel>
      <notes-panel ref="notesPanel" class="bottom-panels col-md-2"></notes-panel>
      <payment-detail-panel ref="paymentDetailPanel"  class="bottom-panels col-md-3 "></payment-detail-panel>
      <billing-detail-panel ref="billingDetailPanel" class="bottom-panels col-md-3" style="margin-left:auto"></billing-detail-panel>
    </div>
    </div>
</div>

</template>

<script>
  import customerPanel from './CustomerPanel'
  import invoiceDetailPanel from './InvoiceDetailPanel'
  import passengerDetailPanel from './PassengerDetailPanel'
  import itineraryDetailPanel from './ItineraryDetailPanel'
  import servicesDetailPanel from './ServicesDetailPanel'
  import notesPanel from './NotesPanel'
  import paymentDetailPanel from './PaymentDetailPanel'
  import billingDetailPanel from './BillingDetailPanel'
  import { mapActions, mapState } from 'vuex'
  import { EventBus } from './../../eventbus/event-bus.js';
  import PrintInvoice from './PrintInvoice'

  export default {
    name: 'Invoices',
    components: {
      'customer-panel': customerPanel,
      'invoice-detail-panel': invoiceDetailPanel,
      'passenger-detail-panel': passengerDetailPanel,
      'itinerary-detail-panel': itineraryDetailPanel,
      'services-detail-panel': servicesDetailPanel,
      'notes-panel': notesPanel,
      'payment-detail-panel': paymentDetailPanel,
      'billing-detail-panel': billingDetailPanel,
      'print-invoice': PrintInvoice
    },
    methods: {
      ...mapActions('invoice', ['newInvoice','getInvoice','createNewInvoiceService','updateInvoiceService','updatePayment']),

        showError(errorMessage) {
            let self = this;
            self.isError=true;
            self.errorMessage = errorMessage;
            setTimeout(function(){ self.isError=false }, 3000);
        },
        showSuccess(successMessage) {
            let self = this;
            self.isSuccess=true;
            self.successMessage = successMessage;
            setTimeout(function(){ self.isSuccess=false }, 3000);
        }
    },
    computed: {
      ...mapState('invoice', ['selectedInvoice','payment','selectedSupplier']),
      ...mapState('settings', ['defaultInvoiceNotes']),
      isAdmin () { return this.$store.getters['account/isAdmin'] },
      canCreateInvoice () { return this.$store.getters['account/canCreateInvoice'] },
      canModifyInvoice () { return this.$store.getters['account/canModifyInvoice'] },
      isCustomerOnly () { return this.$store.getters['account/isCustomerOnly'] }
    },
    watch: {
        '$route.query.id'(newId) {
            if (newId) {
                this.getInvoice(newId)
            } else {
                this.newInvoice()
            }
        },
        defaultInvoiceNotes(newVal) {
            if (this.selectedInvoice && !this.selectedInvoice.id && !this.selectedInvoice.description) {
                this.$store.commit('invoice/updateField', {
                    path: 'selectedInvoice.description',
                    value: newVal
                });
            }
        }
    },
    mounted () {
        let myself = this        
        EventBus.$on('resetInvoice', function () {
          console.log("newInvoice")
          myself.newInvoice()
        });
        EventBus.$on('invoiceSaveAction', function () {

            // RBAC: check if the user has permission to save or update invoices
            if (myself.selectedInvoice['fromServer']) {
              if (!myself.canModifyInvoice) {
                myself.showError("Access Denied: You do not have permission to update invoices")
                return
              }
            } else {
              if (!myself.canCreateInvoice) {
                myself.showError("Access Denied: You do not have permission to create invoices")
                return
              }
            }

            let passengerData = myself.$refs.passengerDetailComponent.passengersData;
            let flightData = myself.$refs.itineraryDetailPanel.flightData;
            let servicesData = myself.$refs.serviceDetailPanel.servicesData;
            let customerData = myself.$refs.customerPanel.customer;

            if (customerData.id==="New" || !customerData.id) {
               myself.showError("Please save customer")
               return
            }
            else if (passengerData.length==0) {
                myself.showError("Please add Passengers")
                return
            }
            else if (flightData.length==0) {
                myself.showError("Please add Flights")
                return
            }
            console.log("before save")
            const sendSms = myself.$refs.billingDetailPanel ? myself.$refs.billingDetailPanel.sendSmsOnCreate : false;
            let payload = {customer:customerData,invoice:myself.selectedInvoice,payment:myself.payment,flights:flightData,passengers:passengerData,supplier:myself.selectedSupplier,services:servicesData,sendSms:sendSms}
            if (myself.selectedInvoice['fromServer']) {
                myself.updateInvoiceService(payload).then(resp=>{
              if (resp!=null) {
                myself.showSuccess("invoice has been updated")
                myself.updatePayment({ inout:null, method:null, description:null, amount:null})
              }
            })
            }
            else {
              myself.createNewInvoiceService(payload).then(resp=>{
              if (resp!=null) {
                myself.showSuccess("invoice has been created")
                myself.updatePayment({ inout:null, method:null, description:null, amount:null})
              }
            }).catch(err=>{
                console.log(err)
                myself.showError(err)
                return
              })
            }
        });

        EventBus.$on('invoicePrintAction', function () {
            console.log("printAction")  
             this.$htmlToPaper('printMe');
        });

        // Listen for notification click — load the invoice by ID
        EventBus.$on('loadInvoiceById', function (invoiceId) {
            console.log("Loading invoice from notification:", invoiceId)
            myself.getInvoice(invoiceId)
        });
    },
    data: () => ({
        errorMessage:null,
        isError:false,
        isSuccess:false,
        successMessage:null
    }),
    created () {
      if (this.$route.query && this.$route.query.id) {
        this.getInvoice(this.$route.query.id)
      } else {
        this.newInvoice()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .print {    
    display: none;
  }
  .invoice-panel {    
     margin-left: auto;
     width:50%
  }
  .top-container {    
     display: flex;
     align-content: space-between;
  }
  .bottom-panels {    
     padding:5px;
  }
  .passenger-details-container {
    margin-top: 0px
  }
  .v-panel {
    margin-bottom:10px
  }
</style>